import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {deferScriptLoading} from './utils'
import {initBraze, stopBraze} from '../integrations/braze/braze-manager'

// Check Didomi consent status for Braze vendor
const hasConsent = (vendorId) => window.Didomi?.getUserConsentStatusForVendor(vendorId)

export function BrazeScript({brazeUserId}) {
    useEffect(() => {
        const {app} = getConfig()

        if (app.IS_BRAZE_ENABLED !== 'true') return undefined

        const vendorId = app.BRAZE_DIDOMI_VENDOR_ID

        const onConsent = () => {
            if (hasConsent(vendorId)) {
                // Load Braze after consent is granted
                deferScriptLoading(() => initBraze(brazeUserId))
            } else {
                // Shutdown Braze if consent is revoked
                stopBraze()
            }
        }

        // Initial consent check
        if (hasConsent(vendorId)) {
            deferScriptLoading(() => initBraze(brazeUserId))
        }

        // Listen for consent changes
        if (vendorId && window.Didomi?.on) {
            window.Didomi.on('consent.changed', onConsent)
            return () => window.Didomi?.off?.('consent.changed', onConsent)
        }

        return undefined
    }, [brazeUserId])

    return null
}
